import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ConfigContext } from '../Context/ConfigContext';
import axios from 'axios';
import './Invoice.css'
import { DateFormaterMonth } from '../Utils/GlobalFunction';

const Invoice = () => {
    const { apiURL, apiHeaderJson, currency } = useContext(ConfigContext);
    const [data, setData] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    const { order_id } = useParams();

    const OrderDetails = async () => {
        const headers = apiHeaderJson;
        try {
            const response = await axios.get(`${apiURL}Order/CustomerOrder`, {
                params: {
                    order_id: order_id
                }, headers
            });
            setData(response.data.cart_info)
            setCustomerData(response.data.customer_info?.[0] || {});
        } catch (error) {
            console.error("Error Add Your Cart:", error);
        }
    };

    useEffect(() => {
        OrderDetails();
    }, [order_id]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    useEffect(() => {
        document.title = 'StoneSkill | Invoice';
    }, []);

    return (
        <>
            <div className="invoice invoice-content invoice-3">
                <div className="back-top-home hover-up mt-30 ml-30">
                    <Link to={"/"} className="hover-up">
                        <i className="fi-rs-home mr-5" />
                        Home
                    </Link>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="invoice-inner">
                                <div className="invoice-info" id="invoice_wrapper">
                                    <div className="invoice-header">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="invoice-name">
                                                    <div className="logo">
                                                        <Link to={"/"}><img src="/assets/imgs/logo/2.png" alt="logo" style={{ width: "300px" }} /></Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6  text-end">
                                                <div className="invoice-numb">
                                                    <h4 className="invoice-header-1 mb-10 mt-20 ml-150">Invoice No: <span className="text-heading">#1970191</span></h4>
                                                    <h6 className='ml-150'>Invoice Date: <span className="text-heading">{customerData?.order_created_date}</span></h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="invoice-top">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="invoice-number">
                                                    <h4 className="invoice-title-1 mb-10">Invoice To</h4>
                                                    <p className="invoice-addr-1">
                                                        <strong>Stone Skill</strong> <br />
                                                        Aurangabad Jalgaon Highway
                                                        <br />Behind Hotel  Pawan <br />
                                                        & lodging Ajanta
                                                        431117
                                                        <br />
                                                        <span>Phone : </span> +91 9049045886<br />
                                                        <span>Email : </span>stoneskill07@gmail.com<br />
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="invoice-number">
                                                    <h4 className="invoice-title-1 mb-10">Bill To</h4>
                                                    <p className="invoice-addr-1">
                                                        <strong>{customerData?.full_name}</strong>,
                                                        {customerData?.area_street_sector},
                                                        {customerData?.landmark}<br />
                                                        {customerData?.flat_house_building} <br />
                                                        {customerData?.town_city},&nbsp;
                                                        {customerData?.state}&nbsp;
                                                        {customerData?.pincode},
                                                        <br />
                                                        {customerData?.country_region}
                                                        <br />
                                                        <span>Phone : {customerData?.mobile_number}</span>
                                                        <br />
                                                        <span>Email : {customerData?.customer_email}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="invoice-number">
                                                    <h4 className="invoice-title-1 mb-10">Overview</h4>
                                                    <p className="invoice-addr-1">
                                                        <strong>Invoice Data:</strong> {DateFormaterMonth(customerData?.order_created_date)} <br />
                                                        <strong>Payment Method: </strong><span className='text-uppercase'>{customerData?.order_payment_method}</span><br />
                                                        <strong>Status:</strong> <span className="text-brand">{customerData?.order_status_label}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="invoice-center">
                                        <div className="table-responsive">
                                            <table className="table table-striped invoice-table">
                                                <thead className="bg-active">
                                                    <tr>
                                                        <th>Item Item</th>
                                                        <th className="text-center">Unit Price</th>
                                                        <th className="text-center">Quantity</th>
                                                        <th className="text-right">Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="item-desc-1">
                                                                        <span>{item?.item_product_title}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="text-center">{customerData.order_currency === "INR" ? "₹" : "$"} {item?.item_product_variant_sale_price}</td>
                                                                <td className="text-center">{item?.item_quantity}</td>
                                                                <td className="text-right">{customerData.order_currency === "INR" ? "₹" : "$"} {item?.item_product_variant_sale_price}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                    <tr>
                                                        <td colSpan={3} className="text-end f-w-600">SubTotal : </td>
                                                        <td className="text-right">{customerData.order_currency === "INR" ? "₹" : "$"} {customerData?.order_sub_total}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={3} className="text-end f-w-600">Grand Total : </td>
                                                        <td className="text-right f-w-600">{customerData.order_currency === "INR" ? "₹" : "$"} {customerData?.order_grand_total}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="invoice-bottom">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div>
                                                    <h3 className="invoice-title-1">Important Note</h3>
                                                    <ul className="important-notes-list-1">
                                                        <li>All amounts shown on this invoice are in Indian Rupees (INR).</li>
                                                        <li>A finance charge of 1.5% will be applied to unpaid balances after 30 days.</li>
                                                        <li>No refunds will be issued once the order is completed.</li>
                                                        <li>Delivery may be delayed due to external dependencies beyond our control.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-offsite">
                                                <div className="text-end">
                                                    <p className="mb-0 text-13">Thank you for your business</p>
                                                    <p><strong>Stone Skill</strong></p>
                                                    <div className="mobile-social-icon mt-50 print-hide">
                                                        <h6>Follow Us</h6>
                                                        <Link to={'/'}><img src="/assets/imgs/theme/icons/icon-facebook-white.svg" alt /></Link>
                                                        <Link to={'/'}><img src="/assets/imgs/theme/icons/icon-twitter-white.svg" alt /></Link>
                                                        <Link to={'https://www.instagram.com/stoneskill07?igsh=MXFxcmpmY2c0MnhnMg%3D%3D'}><img src="/assets/imgs/theme/icons/icon-instagram-white.svg" /></Link>
                                                        <Link to={'/'}><img src="/assets/imgs/theme/icons/icon-pinterest-white.svg" alt /></Link>
                                                        <Link to={'/'}><img src="/assets/imgs/theme/icons/icon-youtube-white.svg" alt /></Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-btn-section clearfix d-print-none">
                                    <button onClick={() => window.print()} className="btn btn-lg btn-custom btn-print hover-up">
                                        <img src="/assets/imgs/theme/icons/icon-print.svg" alt="Print" />Print
                                    </button>
                                    <Link id="invoice_download_btn" className="btn btn-lg btn-custom btn-download hover-up"> <img src="/assets/imgs/theme/icons/icon-download.svg" alt />Download </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Invoice;